import(/* webpackMode: "eager" */ "/build/327b8615-4552-41f1-9829-9e6b7ac3041a/src/app/global-error.tsx");
